import React, { Component } from 'react';
import { Link } from 'react-router-dom';

import { Auth as CognitoAuth } from 'aws-amplify';
import AuthService from './AuthService';
import constants from '../config';

const Auth = new AuthService();

var US_STATES = [
  { code: 'AL', name: 'Alabama' }, { code: 'AK', name: 'Alaska' }, { code: 'AZ', name: 'Arizona' },
  { code: 'AR', name: 'Arkansas' }, { code: 'CA', name: 'California' }, { code: 'CO', name: 'Colorado' },
  { code: 'CT', name: 'Connecticut' }, { code: 'DE', name: 'Delaware' }, { code: 'FL', name: 'Florida' },
  { code: 'GA', name: 'Georgia' }, { code: 'HI', name: 'Hawaii' }, { code: 'ID', name: 'Idaho' },
  { code: 'IL', name: 'Illinois' }, { code: 'IN', name: 'Indiana' }, { code: 'IA', name: 'Iowa' },
  { code: 'KS', name: 'Kansas' }, { code: 'KY', name: 'Kentucky' }, { code: 'LA', name: 'Louisiana' },
  { code: 'ME', name: 'Maine' }, { code: 'MD', name: 'Maryland' }, { code: 'MA', name: 'Massachusetts' },
  { code: 'MI', name: 'Michigan' }, { code: 'MN', name: 'Minnesota' }, { code: 'MS', name: 'Mississippi' },
  { code: 'MO', name: 'Missouri' }, { code: 'MT', name: 'Montana' }, { code: 'NE', name: 'Nebraska' },
  { code: 'NV', name: 'Nevada' }, { code: 'NH', name: 'New Hampshire' }, { code: 'NJ', name: 'New Jersey' },
  { code: 'NM', name: 'New Mexico' }, { code: 'NY', name: 'New York' }, { code: 'NC', name: 'North Carolina' },
  { code: 'ND', name: 'North Dakota' }, { code: 'OH', name: 'Ohio' }, { code: 'OK', name: 'Oklahoma' },
  { code: 'OR', name: 'Oregon' }, { code: 'PA', name: 'Pennsylvania' }, { code: 'RI', name: 'Rhode Island' },
  { code: 'SC', name: 'South Carolina' }, { code: 'SD', name: 'South Dakota' }, { code: 'TN', name: 'Tennessee' },
  { code: 'TX', name: 'Texas' }, { code: 'UT', name: 'Utah' }, { code: 'VT', name: 'Vermont' },
  { code: 'VA', name: 'Virginia' }, { code: 'WA', name: 'Washington' }, { code: 'WV', name: 'West Virginia' },
  { code: 'WI', name: 'Wisconsin' }, { code: 'WY', name: 'Wyoming' }, { code: 'DC', name: 'Washington DC' },
  { code: 'PR', name: 'Puerto Rico' }, { code: 'GU', name: 'Guam' }, { code: 'VI', name: 'US Virgin Islands' },
  { code: 'AS', name: 'American Samoa' }, { code: 'MP', name: 'Northern Mariana Islands' },
];

var LABEL_OPTIONS = ['Home', 'Work', 'Other'];

function emptyAddressForm() {
  return { label: 'Home', street1: '', street2: '', city: '', state: '', zip: '', country: 'US' };
}

class AccountSettings extends Component {
  constructor(props) {
    super(props);
    this.state = {
      id: '',
      email: '',
      phoneNumber: '',
      communityAccount: '',
      didSearch: false,
      searchResult: [],
      notFound: false,
      // Controlled inputs
      emailInput: '',
      phoneInput: '',
      oldPassword: '',
      newPassword: '',
      confirmPassword: '',
      passwordStep: 'idle',
      resetCode: '',
      passwordLoading: false,
      passwordError: '',
      showOldPassword: false,
      showNewPassword: false,
      name: '',
      username: '',
      // Saved values for dirty tracking
      savedEmail: '',
      savedPhone: '',
      // Addresses
      addresses: [],
      addressesLoading: true,
      showAddForm: false,
      editingId: null,
      addressForm: emptyAddressForm(),
      // Legacy single address for backward compat
      street1: '',
      street2: '',
      city: '',
      addressState: '',
      zip: '',
      country: 'US',
      savedStreet1: '',
      savedStreet2: '',
      savedCity: '',
      savedState: '',
      savedZip: '',
      savedCountry: 'US',
      // Delete account
      showDeleteConfirm: false,
      deleteConfirmText: '',
      deleteLoading: false,
      deleteError: '',
      // Confirm modal
      confirmModal: null,
    };
    this.handleAccountEdit = this.handleAccountEdit.bind(this);
    this.handleAddressChange = this.handleAddressChange.bind(this);
    this.handleSendResetCode = this.handleSendResetCode.bind(this);
    this.handleResetCodeSubmit = this.handleResetCodeSubmit.bind(this);
    this.handleDeleteAccount = this.handleDeleteAccount.bind(this);
    this.profile = this.profile.bind(this);
    this.fetchAddresses = this.fetchAddresses.bind(this);
  }

  componentDidMount() {
    this.profile(this.props.user._id);
    this.fetchAddresses();
  }

  profile(userId) {
    var self = this;
    Auth.fetch(constants.DOMAIN + '/api/v1/users/' + userId, {
      mode: 'cors',
      method: 'GET',
    }).then(function(res) {
      var addr = res.profile.address || {};
      self.setState({
        id: userId,
        email: res.profile.email,
        name: res.profile.name,
        phoneNumber: res.profile.phoneNumber,
        username: res.profile.userName,
        communityAccount: res.profile.communityAccount || '',
        emailInput: res.profile.email || '',
        phoneInput: res.profile.phoneNumber || '',
        street1: addr.street1 || '',
        street2: addr.street2 || '',
        city: addr.city || '',
        addressState: addr.state || '',
        zip: addr.zip || '',
        country: addr.country || '',
        savedEmail: res.profile.email || '',
        savedPhone: res.profile.phoneNumber || '',
        savedStreet1: addr.street1 || '',
        savedStreet2: addr.street2 || '',
        savedCity: addr.city || '',
        savedState: addr.state || '',
        savedZip: addr.zip || '',
        savedCountry: addr.country || '',
      });
    }).catch(function(err) {
      console.log(err);
    });
  }

  fetchAddresses() {
    var self = this;
    Auth.fetch(constants.DOMAIN + '/api/v1/users/addresses', {
      mode: 'cors',
      method: 'GET',
    }).then(function(res) {
      self.setState({ addresses: res.addresses || [], addressesLoading: false });
    }).catch(function(err) {
      console.log(err);
      self.setState({ addressesLoading: false });
    });
  }

  handleAccountEdit() {
    var data = new URLSearchParams();
    if (this.state.phoneInput) data.append('phoneNumber', this.state.phoneInput);

    var self = this;
    Auth.fetch(constants.DOMAIN + '/api/v1/users/account', {
      mode: 'cors',
      method: 'PATCH',
      body: data,
    }).then(function(res) {
      self.setState({
        email: res.email,
        phoneNumber: res.phoneNumber,
        emailInput: res.email || '',
        phoneInput: res.phoneNumber || '',
        savedEmail: res.email || '',
        savedPhone: res.phoneNumber || '',
      });
      window.dispatchEvent(new CustomEvent('toast', { detail: { text: 'Contact info saved!', type: 'success' } }));
    }).catch(function(err) {
      window.dispatchEvent(new CustomEvent('toast', { detail: { text: 'Unable to update contact info', type: 'error' } }));
      console.log(err);
    });
  }

  handleSendResetCode() {
    var self = this;
    var email = this.state.email.toLowerCase().trim();
    if (!email) {
      this.setState({ passwordError: 'Unable to find your email. Please reload the page.' });
      return;
    }
    if (!this.state.oldPassword) {
      this.setState({ passwordError: 'Please enter your current password' });
      return;
    }
    this.setState({ passwordLoading: true, passwordError: '' });

    // Verify current password via Cognito before sending reset code
    CognitoAuth.signIn(email, this.state.oldPassword)
      .then(function() {
        return Auth.forgotPassword(email);
      })
      .then(function() {
        self.setState({ passwordLoading: false, passwordStep: 'code', passwordError: '' });
      })
      .catch(function(err) {
        var msg = 'Failed to send verification code. Please try again.';
        if (err.code === 'NotAuthorizedException' || err.name === 'NotAuthorizedException') {
          msg = 'Current password is incorrect';
        } else if (err.code === 'LimitExceededException' || err.name === 'LimitExceededException') {
          msg = 'Too many attempts. Please try again later.';
        }
        self.setState({ passwordLoading: false, passwordError: msg });
      });
  }

  handleResetCodeSubmit() {
    var self = this;
    var code = this.state.resetCode.trim();
    var newPassword = this.state.newPassword;

    if (!code) {
      this.setState({ passwordError: 'Please enter the verification code' });
      return;
    }
    if (!newPassword || newPassword.length < 8) {
      this.setState({ passwordError: 'Password must be at least 8 characters' });
      return;
    }
    if (!/[A-Z]/.test(newPassword)) {
      this.setState({ passwordError: 'Password must contain at least one uppercase letter' });
      return;
    }
    if (!/[0-9]/.test(newPassword)) {
      this.setState({ passwordError: 'Password must contain at least one number' });
      return;
    }
    if (newPassword !== this.state.confirmPassword) {
      this.setState({ passwordError: 'New passwords do not match' });
      return;
    }

    this.setState({ passwordLoading: true, passwordError: '' });

    var email = this.state.email.toLowerCase().trim();

    Auth.forgotPasswordSubmit(email, code, newPassword)
      .then(function() {
        self.setState({ passwordLoading: false, passwordStep: 'done', resetCode: '', newPassword: '', confirmPassword: '' });
        window.dispatchEvent(new CustomEvent('toast', { detail: { text: 'Password updated!', type: 'success' } }));
      })
      .catch(function(err) {
        var msg = 'Failed to reset password. Please try again.';
        if (err.code === 'CodeMismatchException' || err.name === 'CodeMismatchException') {
          msg = 'Invalid verification code. Please check and try again.';
        } else if (err.code === 'ExpiredCodeException' || err.name === 'ExpiredCodeException') {
          msg = 'Code has expired. Please request a new one.';
        } else if (err.code === 'InvalidPasswordException' || err.name === 'InvalidPasswordException') {
          msg = err.message || 'Password does not meet requirements.';
        }
        self.setState({ passwordLoading: false, passwordError: msg });
      });
  }

  handleAddressChange() {
    var self = this;
    var data = new URLSearchParams();
    if (this.state.street1) data.append('street1', this.state.street1);
    if (this.state.street2) data.append('street2', this.state.street2);
    if (this.state.city) data.append('city', this.state.city);
    if (this.state.addressState) data.append('state', this.state.addressState);
    if (this.state.zip) data.append('zip', this.state.zip);
    if (this.state.country) data.append('country', this.state.country);

    Auth.fetch(constants.DOMAIN + '/api/v1/users/account/address', {
      mode: 'cors',
      method: 'PATCH',
      body: data,
    }).then(function() {
      self.setState({
        savedStreet1: self.state.street1,
        savedStreet2: self.state.street2,
        savedCity: self.state.city,
        savedState: self.state.addressState,
        savedZip: self.state.zip,
        savedCountry: self.state.country,
      });
      self.fetchAddresses();
      window.dispatchEvent(new CustomEvent('toast', { detail: { text: 'Address saved!', type: 'success' } }));
    }).catch(function(err) {
      window.dispatchEvent(new CustomEvent('toast', { detail: { text: 'Failed to save address', type: 'error' } }));
      console.log(err);
    });
  }

  addNewAddress() {
    var self = this;
    var form = this.state.addressForm;
    if (!form.street1 || !form.city || !form.state || !form.zip) {
      window.dispatchEvent(new CustomEvent('toast', { detail: { text: 'Please fill in required fields', type: 'error' } }));
      return;
    }
    Auth.fetch(constants.DOMAIN + '/api/v1/users/addresses', {
      mode: 'cors',
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(form),
    }).then(function() {
      self.setState({ showAddForm: false, addressForm: emptyAddressForm() });
      self.fetchAddresses();
      window.dispatchEvent(new CustomEvent('toast', { detail: { text: 'Address added!', type: 'success' } }));
    }).catch(function(err) {
      var msg = 'Failed to add address';
      if (err && err.response) {
        err.response.json().then(function(b) {
          window.dispatchEvent(new CustomEvent('toast', { detail: { text: b.error || msg, type: 'error' } }));
        }).catch(function() {
          window.dispatchEvent(new CustomEvent('toast', { detail: { text: msg, type: 'error' } }));
        });
      } else {
        window.dispatchEvent(new CustomEvent('toast', { detail: { text: msg, type: 'error' } }));
      }
    });
  }

  saveEditAddress(addressId) {
    var self = this;
    var form = this.state.addressForm;
    Auth.fetch(constants.DOMAIN + '/api/v1/users/addresses/' + addressId, {
      mode: 'cors',
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(form),
    }).then(function() {
      self.setState({ editingId: null, addressForm: emptyAddressForm() });
      self.fetchAddresses();
      window.dispatchEvent(new CustomEvent('toast', { detail: { text: 'Address updated!', type: 'success' } }));
    }).catch(function() {
      window.dispatchEvent(new CustomEvent('toast', { detail: { text: 'Failed to update address', type: 'error' } }));
    });
  }

  deleteAddressConfirm(addressId) {
    var self = this;
    self.setState({
      confirmModal: {
        title: 'Delete Address',
        message: 'Are you sure you want to delete this address?',
        confirmLabel: 'Delete',
        onConfirm: function() {
          self.setState({ confirmModal: null });
          Auth.fetch(constants.DOMAIN + '/api/v1/users/addresses/' + addressId, {
            mode: 'cors',
            method: 'DELETE',
          }).then(function() {
            self.fetchAddresses();
            window.dispatchEvent(new CustomEvent('toast', { detail: { text: 'Address deleted', type: 'success' } }));
          }).catch(function() {
            window.dispatchEvent(new CustomEvent('toast', { detail: { text: 'Failed to delete address', type: 'error' } }));
          });
        },
      },
    });
  }

  setAddressDefault(addressId) {
    var self = this;
    Auth.fetch(constants.DOMAIN + '/api/v1/users/addresses/' + addressId + '/default', {
      mode: 'cors',
      method: 'PATCH',
    }).then(function() {
      self.fetchAddresses();
      window.dispatchEvent(new CustomEvent('toast', { detail: { text: 'Default address updated', type: 'success' } }));
    }).catch(function() {
      window.dispatchEvent(new CustomEvent('toast', { detail: { text: 'Failed to set default', type: 'error' } }));
    });
  }

  handleCommunityAccount() {
    var appUse = this.state.communityAccount;
    if (appUse) {
      var data = new URLSearchParams();
      data.append('communityAccount', appUse);
      Auth.fetch(constants.DOMAIN + '/api/v1/users/account', {
        mode: 'cors',
        method: 'PATCH',
        body: data,
      }).then(function() {
        window.dispatchEvent(new CustomEvent('toast', { detail: { text: 'Community account connected!', type: 'success' } }));
      }).catch(function(err) {
        window.dispatchEvent(new CustomEvent('toast', { detail: { text: 'Unable to connect account', type: 'error' } }));
        console.log(err);
      });
    } else {
      window.dispatchEvent(new CustomEvent('toast', { detail: { text: 'Please enter your Primal TCG App username', type: 'info' } }));
    }
  }

  handleDeleteAccount() {
    var self = this;
    this.setState({ deleteLoading: true, deleteError: '' });
    Auth.fetch(constants.DOMAIN + '/api/v1/users/account', {
      mode: 'cors',
      method: 'DELETE',
    }).then(function() {
      Auth.logout();
      window.location.href = '/';
    }).catch(function(err) {
      var msg = 'An error occurred while deleting your account.';
      if (err && err.response) {
        err.response.json().then(function(body) {
          self.setState({ deleteLoading: false, deleteError: body.error || msg });
        }).catch(function() {
          self.setState({ deleteLoading: false, deleteError: msg });
        });
      } else {
        self.setState({ deleteLoading: false, deleteError: msg });
      }
    });
  }

  renderAddressForm(isEdit) {
    var self = this;
    var form = this.state.addressForm;
    var inputClass = 'tw-w-full tw-bg-[#f5f5f5] dark:tw-bg-[#0f0f0f] tw-rounded-xl tw-px-5 tw-py-3 tw-border tw-border-[#e0e0e0] dark:tw-border-[#333] focus:tw-border-brand-gold tw-outline-none tw-text-[#111] dark:tw-text-white tw-transition-colors';
    var labelClass = 'tw-block tw-text-sm tw-font-medium tw-text-[#555] dark:tw-text-[#aaa] tw-mb-2';

    return (
      <div className="tw-space-y-3">
        <div>
          <label className={labelClass}>Label</label>
          <select
            className={inputClass}
            value={form.label}
            onChange={function(e) { self.setState({ addressForm: Object.assign({}, form, { label: e.target.value }) }); }}
          >
            {LABEL_OPTIONS.map(function(l) { return <option key={l} value={l}>{l}</option>; })}
          </select>
        </div>
        <div>
          <label className={labelClass}>Street 1 *</label>
          <input
            type="text"
            className={inputClass}
            value={form.street1}
            onChange={function(e) { self.setState({ addressForm: Object.assign({}, form, { street1: e.target.value }) }); }}
            placeholder="Street address"
          />
        </div>
        <div>
          <label className={labelClass}>Street 2</label>
          <input
            type="text"
            className={inputClass}
            value={form.street2}
            onChange={function(e) { self.setState({ addressForm: Object.assign({}, form, { street2: e.target.value }) }); }}
            placeholder="Apt, suite, etc."
          />
        </div>
        <div className="tw-grid tw-grid-cols-2 tw-gap-3">
          <div>
            <label className={labelClass}>City *</label>
            <input
              type="text"
              className={inputClass}
              value={form.city}
              onChange={function(e) { self.setState({ addressForm: Object.assign({}, form, { city: e.target.value }) }); }}
              placeholder="City"
            />
          </div>
          <div>
            <label className={labelClass}>State *</label>
            <select
              className={inputClass}
              value={form.state}
              onChange={function(e) { self.setState({ addressForm: Object.assign({}, form, { state: e.target.value }) }); }}
            >
              <option value="">Select</option>
              {US_STATES.map(function(s) { return <option key={s.code} value={s.code}>{s.name}</option>; })}
            </select>
          </div>
        </div>
        <div className="tw-grid tw-grid-cols-2 tw-gap-3">
          <div>
            <label className={labelClass}>Zip *</label>
            <input
              type="text"
              className={inputClass}
              value={form.zip}
              onChange={function(e) { self.setState({ addressForm: Object.assign({}, form, { zip: e.target.value }) }); }}
              placeholder="Zip code"
            />
          </div>
          <div>
            <label className={labelClass}>Country</label>
            {/* USA-only: country locked to US. Uncomment below to allow international */}
            {/* <input
              type="text"
              className={inputClass}
              value={form.country}
              onChange={function(e) { self.setState({ addressForm: Object.assign({}, form, { country: e.target.value }) }); }}
              placeholder="US"
            /> */}
            <input type="text" value="US" readOnly className={inputClass + ' tw-opacity-60 tw-cursor-not-allowed'} />
          </div>
        </div>
        <div className="tw-flex tw-gap-3 tw-pt-2">
          <button
            onClick={function() {
              if (isEdit) {
                self.saveEditAddress(self.state.editingId);
              } else {
                self.addNewAddress();
              }
            }}
            className="tw-px-6 tw-py-2.5 tw-rounded-lg tw-bg-brand-gold tw-text-white tw-font-semibold tw-text-sm tw-border-none tw-cursor-pointer hover:tw-bg-brand-gold/90 tw-transition-colors"
          >
            {isEdit ? 'Save Changes' : 'Add Address'}
          </button>
          <button
            onClick={function() { self.setState({ showAddForm: false, editingId: null, addressForm: emptyAddressForm() }); }}
            className="tw-px-6 tw-py-2.5 tw-rounded-lg tw-text-sm tw-font-medium tw-cursor-pointer tw-transition-colors tw-border-none tw-bg-[#f5f5f5] dark:tw-bg-[#333] tw-text-[#555] dark:tw-text-[#aaa]"
          >
            Cancel
          </button>
        </div>
      </div>
    );
  }

  render() {
    var self = this;
    var inputClass = 'tw-w-full tw-bg-[#f5f5f5] dark:tw-bg-[#0f0f0f] tw-rounded-xl tw-px-5 tw-py-3 tw-border tw-border-[#e0e0e0] dark:tw-border-[#333] focus:tw-border-brand-gold tw-outline-none tw-text-[#111] dark:tw-text-white tw-transition-colors';
    var labelClass = 'tw-block tw-text-sm tw-font-medium tw-text-[#555] dark:tw-text-[#aaa] tw-mb-2';
    var cardClass = 'tw-bg-white dark:tw-bg-[#1a1a1a] tw-rounded-xl tw-p-6 tw-mb-6';
    var cardStyle = { border: '1px solid #e0e0e0', boxShadow: '0 1px 4px rgba(0,0,0,0.06)' };
    var btnClass = 'tw-px-8 tw-py-3 tw-rounded-lg tw-bg-brand-gold tw-text-white tw-font-semibold tw-text-sm tw-border-none tw-cursor-pointer hover:tw-bg-brand-gold/90 tw-transition-colors disabled:tw-opacity-40 disabled:tw-cursor-not-allowed';
    var contactChanged = this.state.phoneInput !== this.state.savedPhone;
    var addresses = this.state.addresses;
    var hasArrayAddresses = addresses.filter(function(a) { return a._id !== 'primary'; }).length;

    return (
      <div>
        {/* Contact Info */}
        <div className={cardClass} style={cardStyle}>
          <h3 className="tw-text-lg tw-font-semibold tw-text-[#111] dark:tw-text-white tw-mb-6">Contact Info</h3>
          <div className="tw-space-y-4">
            <div>
              <label className={labelClass}>Email</label>
              <input
                type="email"
                className={inputClass}
                value={this.state.emailInput}
                readOnly
                style={{ opacity: 0.6, cursor: 'not-allowed' }}
              />
              <p className="tw-text-xs tw-text-[#999] tw-mt-1 tw-mb-0">Your email is your login identity and cannot be changed.</p>
            </div>
            <div>
              <label className={labelClass}>Phone</label>
              <input
                type="tel"
                className={inputClass}
                value={this.state.phoneInput}
                onChange={function(e) { self.setState({ phoneInput: e.target.value }); }}
                placeholder="Phone number"
              />
            </div>
            <button onClick={this.handleAccountEdit} className={btnClass} disabled={!contactChanged}>
              Save Contact Info
            </button>
          </div>
        </div>

        {/* Shipping Addresses */}
        <div className={cardClass} style={cardStyle}>
          <div className="tw-flex tw-items-center tw-justify-between tw-mb-6">
            <h3 className="tw-text-lg tw-font-semibold tw-text-[#111] dark:tw-text-white">Shipping Addresses</h3>
            {hasArrayAddresses < 5 && !this.state.showAddForm && !this.state.editingId ? (
              <button
                onClick={function() { self.setState({ showAddForm: true, editingId: null, addressForm: emptyAddressForm() }); }}
                className="tw-px-4 tw-py-2 tw-rounded-lg tw-text-sm tw-font-medium tw-border tw-border-brand-gold tw-text-brand-gold tw-bg-transparent tw-cursor-pointer hover:tw-bg-brand-gold/10 tw-transition-colors"
              >
                <i className="fa fa-plus tw-mr-1"></i>Add Address
              </button>
            ) : null}
          </div>

          {/* Add Form */}
          {this.state.showAddForm && !this.state.editingId ? (
            <div className="tw-mb-6 tw-p-4 tw-rounded-lg tw-bg-[#f5f5f5] dark:tw-bg-[#0f0f0f]">
              <h4 className="tw-text-sm tw-font-semibold tw-text-[#111] dark:tw-text-white tw-mb-4">New Address</h4>
              {this.renderAddressForm(false)}
            </div>
          ) : null}

          {/* Address List */}
          {this.state.addressesLoading ? (
            <div className="tw-flex tw-items-center tw-justify-center tw-py-6">
              <div className="tw-animate-spin tw-rounded-full tw-h-6 tw-w-6 tw-border-t-2 tw-border-b-2 tw-border-brand-gold"></div>
            </div>
          ) : addresses.length > 0 ? (
            <div className="tw-space-y-3">
              {addresses.map(function(addr) {
                var isEditing = self.state.editingId === addr._id;

                if (isEditing) {
                  return (
                    <div key={addr._id} className="tw-p-4 tw-rounded-lg tw-bg-[#f5f5f5] dark:tw-bg-[#0f0f0f]">
                      <h4 className="tw-text-sm tw-font-semibold tw-text-[#111] dark:tw-text-white tw-mb-4">Edit Address</h4>
                      {self.renderAddressForm(true)}
                    </div>
                  );
                }

                return (
                  <div key={addr._id} className="tw-flex tw-items-start tw-gap-4 tw-p-4 tw-rounded-lg tw-bg-[#f5f5f5] dark:tw-bg-[#0f0f0f]">
                    <div className="tw-w-10 tw-h-10 tw-rounded-lg tw-bg-white dark:tw-bg-[#1a1a1a] tw-flex tw-items-center tw-justify-center tw-flex-shrink-0" style={{ border: '1px solid #e0e0e0' }}>
                      <i className={'fa ' + (addr.label === 'Work' ? 'fa-briefcase' : addr.label === 'Other' ? 'fa-map-marker' : 'fa-home') + ' tw-text-[#555] dark:tw-text-[#aaa]'}></i>
                    </div>
                    <div className="tw-flex-1 tw-min-w-0">
                      <div className="tw-flex tw-items-center tw-gap-2 tw-mb-1">
                        <span className="tw-text-sm tw-font-medium tw-text-[#111] dark:tw-text-white">{addr.label}</span>
                        {addr.isDefault ? (
                          <span className="tw-inline-flex tw-items-center tw-px-2 tw-py-0.5 tw-rounded-full tw-text-xs tw-font-medium tw-bg-brand-gold/10 tw-text-brand-gold">Default</span>
                        ) : null}
                      </div>
                      <p className="tw-text-sm tw-text-[#555] dark:tw-text-[#aaa]">
                        {addr.street1}{addr.street2 ? ', ' + addr.street2 : ''}<br />
                        {addr.city}{addr.state ? ', ' + addr.state : ''} {addr.zip}
                      </p>
                    </div>
                    <div className="tw-flex tw-items-center tw-gap-1 tw-flex-shrink-0">
                      {!addr.isDefault ? (
                        <button
                          onClick={function() { self.setAddressDefault(addr._id); }}
                          className="tw-px-2 tw-py-1.5 tw-rounded tw-text-xs tw-font-medium tw-border tw-border-brand-gold tw-text-brand-gold tw-bg-transparent tw-cursor-pointer hover:tw-bg-brand-gold/10 tw-transition-colors"
                          title="Set as default"
                        >
                          Default
                        </button>
                      ) : null}
                      <button
                        onClick={function() {
                          self.setState({
                            editingId: addr._id,
                            showAddForm: false,
                            addressForm: {
                              label: addr.label || 'Home',
                              street1: addr.street1 || '',
                              street2: addr.street2 || '',
                              city: addr.city || '',
                              state: addr.state || '',
                              zip: addr.zip || '',
                              country: addr.country || 'US',
                            },
                          });
                        }}
                        className="tw-p-1.5 tw-rounded tw-text-xs tw-border-none tw-bg-transparent tw-cursor-pointer tw-text-[#888] hover:tw-text-brand-gold tw-transition-colors"
                        title="Edit"
                      >
                        <i className="fa fa-pencil"></i>
                      </button>
                      {addr._id !== 'primary' ? (
                        <button
                          onClick={function() { self.deleteAddressConfirm(addr._id); }}
                          className="tw-p-1.5 tw-rounded tw-text-xs tw-border-none tw-bg-transparent tw-cursor-pointer tw-transition-colors"
                          style={{ color: '#dc2626' }}
                          title="Delete"
                        >
                          <i className="fa fa-trash"></i>
                        </button>
                      ) : null}
                    </div>
                  </div>
                );
              })}
            </div>
          ) : (
            <div>
              <p className="tw-text-sm tw-text-[#888] tw-mb-4">No addresses saved yet.</p>
              {/* Fallback: legacy single address form */}
              <div className="tw-space-y-4">
                <div>
                  <label className={labelClass}>Street 1</label>
                  <input
                    type="text"
                    className={inputClass}
                    value={this.state.street1}
                    onChange={function(e) { self.setState({ street1: e.target.value }); }}
                    placeholder="Street address"
                  />
                </div>
                <div>
                  <label className={labelClass}>Street 2</label>
                  <input
                    type="text"
                    className={inputClass}
                    value={this.state.street2}
                    onChange={function(e) { self.setState({ street2: e.target.value }); }}
                    placeholder="Apt, suite, etc."
                  />
                </div>
                <div className="tw-grid tw-grid-cols-1 md:tw-grid-cols-2 tw-gap-4">
                  <div>
                    <label className={labelClass}>City</label>
                    <input
                      type="text"
                      className={inputClass}
                      value={this.state.city}
                      onChange={function(e) { self.setState({ city: e.target.value }); }}
                      placeholder="City"
                    />
                  </div>
                  <div>
                    <label className={labelClass}>State</label>
                    <select
                      className={inputClass}
                      value={this.state.addressState}
                      onChange={function(e) { self.setState({ addressState: e.target.value }); }}
                    >
                      <option value="">Select state</option>
                      {US_STATES.map(function(s) {
                        return <option key={s.code} value={s.code}>{s.name}</option>;
                      })}
                    </select>
                  </div>
                </div>
                <div className="tw-grid tw-grid-cols-1 md:tw-grid-cols-2 tw-gap-4">
                  <div>
                    <label className={labelClass}>Zip Code</label>
                    <input
                      type="text"
                      className={inputClass}
                      value={this.state.zip}
                      onChange={function(e) { self.setState({ zip: e.target.value }); }}
                      placeholder="Zip code"
                    />
                  </div>
                  <div>
                    <label className={labelClass}>Country</label>
                    {/* USA-only: country locked to US. Uncomment below to allow international */}
                    {/* <input
                      type="text"
                      className={inputClass}
                      value={this.state.country}
                      onChange={function(e) { self.setState({ country: e.target.value }); }}
                      placeholder="Country"
                    /> */}
                    <input type="text" value="US" readOnly className={inputClass + ' tw-opacity-60 tw-cursor-not-allowed'} />
                  </div>
                </div>
                <button onClick={this.handleAddressChange} className={btnClass}>
                  Save Address
                </button>
              </div>
            </div>
          )}

          {hasArrayAddresses >= 5 ? (
            <p className="tw-text-xs tw-text-[#888] tw-mt-3">
              <i className="fa fa-info-circle tw-mr-1"></i>Maximum of 5 saved addresses reached
            </p>
          ) : null}
        </div>

        {/* Password */}
        <div className={cardClass} style={cardStyle}>
          <h3 className="tw-text-lg tw-font-semibold tw-text-[#111] dark:tw-text-white tw-mb-6">Password</h3>

          {this.state.passwordStep === 'idle' ? (
            <div className="tw-space-y-4">
              <p className="tw-text-sm tw-text-[#555] dark:tw-text-[#aaa]">
                Enter your current password, then we'll send a verification code to your email.
              </p>
              <div>
                <label className={labelClass}>Current Password</label>
                <div className="tw-relative">
                  <input
                    type={this.state.showOldPassword ? 'text' : 'password'}
                    className={inputClass}
                    value={this.state.oldPassword}
                    onChange={function(e) { self.setState({ oldPassword: e.target.value, passwordError: '' }); }}
                    placeholder="Enter current password"
                    style={{ paddingRight: '48px' }}
                  />
                  <button
                    type="button"
                    onClick={function() { self.setState({ showOldPassword: !self.state.showOldPassword }); }}
                    className="tw-absolute tw-right-3 tw-top-1/2 tw-border-none tw-bg-transparent tw-cursor-pointer tw-text-[#888] hover:tw-text-[#555] tw-transition-colors tw-p-1"
                    style={{ transform: 'translateY(-50%)' }}
                  >
                    <i className={'fa ' + (this.state.showOldPassword ? 'fa-eye-slash' : 'fa-eye')}></i>
                  </button>
                </div>
              </div>
              {this.state.passwordError ? (
                <p className="tw-text-sm tw-text-red-600">{this.state.passwordError}</p>
              ) : null}
              <button
                onClick={this.handleSendResetCode}
                className={btnClass}
                disabled={this.state.passwordLoading || !this.state.oldPassword}
              >
                {this.state.passwordLoading ? 'Verifying...' : 'Change Password'}
              </button>
            </div>
          ) : this.state.passwordStep === 'code' ? (
            <div className="tw-space-y-4">
              <p className="tw-text-sm tw-text-[#555] dark:tw-text-[#aaa]">
                We sent a verification code to <strong className="tw-text-[#111] dark:tw-text-white">{this.state.email}</strong>. Enter it below with your new password.
              </p>

              <div>
                <label className={labelClass}>Verification Code</label>
                <input
                  type="text"
                  className={inputClass}
                  value={this.state.resetCode}
                  onChange={function(e) { self.setState({ resetCode: e.target.value, passwordError: '' }); }}
                  placeholder="Enter 6-digit code"
                  autoComplete="one-time-code"
                  autoFocus
                  maxLength={6}
                  style={{ textAlign: 'center', letterSpacing: '0.3em', fontFamily: 'monospace', fontSize: '20px' }}
                />
              </div>

              {function() {
                var pw = self.state.newPassword;
                var hasLength = pw.length >= 8;
                var hasUpper = /[A-Z]/.test(pw);
                var hasNumber = /[0-9]/.test(pw);
                var pwValid = hasLength && hasUpper && hasNumber;
                var pwBorder = pw ? (pwValid ? '#22c55e' : '#ef4444') : undefined;
                var cp = self.state.confirmPassword;
                var cpMatch = cp && cp === pw;
                var cpBorder = cp ? (cpMatch && pwValid ? '#22c55e' : '#ef4444') : undefined;

                return (
                  <React.Fragment>
                    <div>
                      <label className={labelClass}>New Password</label>
                      <div className="tw-relative">
                        <input
                          type={self.state.showNewPassword ? 'text' : 'password'}
                          className={inputClass}
                          value={pw}
                          onChange={function(e) { self.setState({ newPassword: e.target.value, passwordError: '' }); }}
                          placeholder="At least 8 characters"
                          style={{ paddingRight: '48px', borderColor: pwBorder }}
                        />
                        <button
                          type="button"
                          onClick={function() { self.setState({ showNewPassword: !self.state.showNewPassword }); }}
                          className="tw-absolute tw-right-3 tw-top-1/2 tw-border-none tw-bg-transparent tw-cursor-pointer tw-text-[#888] hover:tw-text-[#555] tw-transition-colors tw-p-1"
                          style={{ transform: 'translateY(-50%)' }}
                        >
                          <i className={'fa ' + (self.state.showNewPassword ? 'fa-eye-slash' : 'fa-eye')}></i>
                        </button>
                      </div>
                      {pw ? (
                        <div className="tw-mt-2 tw-space-y-0.5">
                          <p className="tw-text-xs tw-mb-0" style={{ color: hasLength ? '#22c55e' : '#ef4444' }}>
                            <i className={'fa ' + (hasLength ? 'fa-check' : 'fa-times') + ' tw-mr-1.5'} style={{ width: '12px' }}></i>
                            At least 8 characters
                          </p>
                          <p className="tw-text-xs tw-mb-0" style={{ color: hasUpper ? '#22c55e' : '#ef4444' }}>
                            <i className={'fa ' + (hasUpper ? 'fa-check' : 'fa-times') + ' tw-mr-1.5'} style={{ width: '12px' }}></i>
                            One uppercase letter
                          </p>
                          <p className="tw-text-xs tw-mb-0" style={{ color: hasNumber ? '#22c55e' : '#ef4444' }}>
                            <i className={'fa ' + (hasNumber ? 'fa-check' : 'fa-times') + ' tw-mr-1.5'} style={{ width: '12px' }}></i>
                            One number
                          </p>
                        </div>
                      ) : (
                        <p className="tw-text-xs tw-text-[#888] tw-mt-1 tw-mb-0">Must be at least 8 characters with a number and uppercase letter</p>
                      )}
                    </div>

                    <div>
                      <label className={labelClass}>Confirm Password</label>
                      <div className="tw-relative">
                        <input
                          type={self.state.showNewPassword ? 'text' : 'password'}
                          className={inputClass}
                          value={cp}
                          onChange={function(e) { self.setState({ confirmPassword: e.target.value, passwordError: '' }); }}
                          placeholder="Confirm new password"
                          style={{ paddingRight: '48px', borderColor: cpBorder }}
                        />
                        <button
                          type="button"
                          onClick={function() { self.setState({ showNewPassword: !self.state.showNewPassword }); }}
                          className="tw-absolute tw-right-3 tw-top-1/2 tw-border-none tw-bg-transparent tw-cursor-pointer tw-text-[#888] hover:tw-text-[#555] tw-transition-colors tw-p-1"
                          style={{ transform: 'translateY(-50%)' }}
                        >
                          <i className={'fa ' + (self.state.showNewPassword ? 'fa-eye-slash' : 'fa-eye')}></i>
                        </button>
                      </div>
                      {cp ? (
                        <p className="tw-text-xs tw-mt-1 tw-mb-0" style={{ color: cpMatch ? '#22c55e' : '#ef4444' }}>
                          <i className={'fa ' + (cpMatch ? 'fa-check' : 'fa-times') + ' tw-mr-1.5'} style={{ width: '12px' }}></i>
                          {cpMatch ? 'Passwords match' : 'Passwords do not match'}
                        </p>
                      ) : null}
                    </div>
                  </React.Fragment>
                );
              }()}

              {this.state.passwordError ? (
                <p className="tw-text-sm tw-text-red-600">{this.state.passwordError}</p>
              ) : null}

              <div className="tw-flex tw-items-center tw-gap-3">
                <button
                  onClick={this.handleResetCodeSubmit}
                  className={btnClass}
                  disabled={this.state.passwordLoading}
                >
                  {this.state.passwordLoading ? 'Updating...' : 'Reset Password'}
                </button>
                <button
                  onClick={function() { self.setState({ passwordStep: 'idle', resetCode: '', newPassword: '', confirmPassword: '', passwordError: '', showNewPassword: false }); }}
                  className="tw-px-6 tw-py-3 tw-rounded-lg tw-text-sm tw-font-medium tw-cursor-pointer tw-transition-colors tw-border-none tw-bg-[#f5f5f5] dark:tw-bg-[#333] tw-text-[#555] dark:tw-text-[#aaa]"
                >
                  Cancel
                </button>
              </div>

              <button
                onClick={function() {
                  self.setState({ passwordLoading: true, passwordError: '' });
                  var email = self.state.email.toLowerCase().trim();
                  Auth.forgotPassword(email)
                    .then(function() { self.setState({ passwordLoading: false }); })
                    .catch(function(err) {
                      var msg = err.code === 'LimitExceededException' ? 'Too many attempts. Please try again later.' : 'Failed to resend code.';
                      self.setState({ passwordLoading: false, passwordError: msg });
                    });
                }}
                disabled={this.state.passwordLoading}
                className="tw-text-brand-gold hover:tw-text-brand-gold-dark tw-bg-transparent tw-border-0 tw-cursor-pointer tw-text-xs tw-p-0"
              >
                Resend code
              </button>
            </div>
          ) : (
            <div className="tw-text-center tw-py-4">
              <div className="tw-w-12 tw-h-12 tw-rounded-full tw-mx-auto tw-mb-3 tw-flex tw-items-center tw-justify-center" style={{ backgroundColor: 'rgba(34,197,94,0.1)' }}>
                <i className="fa fa-check tw-text-lg" style={{ color: '#22c55e' }}></i>
              </div>
              <p className="tw-text-sm tw-font-medium tw-text-[#111] dark:tw-text-white tw-mb-4">Password updated successfully!</p>
              <button
                onClick={function() { self.setState({ passwordStep: 'idle', oldPassword: '', passwordError: '', showOldPassword: false }); }}
                className={btnClass}
              >
                Done
              </button>
            </div>
          )}
        </div>

        {/* Account Standing */}
        <Link
          to="/account-standing"
          className={cardClass + ' tw-no-underline tw-flex tw-items-center tw-justify-between tw-group'}
          style={Object.assign({}, cardStyle, { cursor: 'pointer' })}
        >
          <div className="tw-flex tw-items-center tw-gap-4">
            <div
              className="tw-w-10 tw-h-10 tw-rounded-full tw-flex tw-items-center tw-justify-center tw-flex-shrink-0"
              style={{ backgroundColor: 'rgba(201,168,76,0.1)', color: '#c9a84c' }}
            >
              <i className="fa fa-shield" />
            </div>
            <div>
              <h3 className="tw-text-sm tw-font-semibold tw-text-[#111] dark:tw-text-white tw-mb-0">Account Standing</h3>
              <p className="tw-text-xs tw-text-[#888] tw-mb-0">View strikes, account status, and appeal info</p>
            </div>
          </div>
          <div className="tw-flex tw-items-center tw-gap-2">
            {this.props.strikeNotifCount > 0 && (
              <span
                className="tw-min-w-[20px] tw-h-5 tw-rounded-full tw-flex tw-items-center tw-justify-center tw-text-xs tw-font-bold tw-text-white tw-px-1"
                style={{ backgroundColor: '#ef4444' }}
              >
                {this.props.strikeNotifCount}
              </span>
            )}
            <i className="fa fa-chevron-right tw-text-[#ccc] dark:tw-text-[#555]" />
          </div>
        </Link>

        {/* Danger Zone — Delete Account */}
        <div className={cardClass} style={{ border: '1px solid #ef4444', boxShadow: '0 1px 4px rgba(239,68,68,0.10)' }}>
          <h3 className="tw-text-lg tw-font-semibold tw-text-red-600 tw-mb-4">Delete Account</h3>
          <p className="tw-text-sm tw-text-[#555] dark:tw-text-[#aaa] tw-mb-4">
            This action is permanent. Your profile will be removed and personal data scrubbed. Some transaction records may be retained for accounting.
          </p>
          {!this.state.showDeleteConfirm ? (
            <button
              onClick={function() { self.setState({ showDeleteConfirm: true, deleteConfirmText: '', deleteError: '' }); }}
              className="tw-px-6 tw-py-3 tw-rounded-lg tw-bg-red-600 tw-text-white tw-font-semibold tw-text-sm tw-border-none tw-cursor-pointer hover:tw-bg-red-700 tw-transition-colors"
            >
              Delete My Account
            </button>
          ) : (
            <div className="tw-space-y-3">
              <p className="tw-text-sm tw-font-medium tw-text-[#111] dark:tw-text-white">
                Type <span className="tw-font-bold">DELETE</span> to confirm:
              </p>
              <input
                type="text"
                className={inputClass}
                value={this.state.deleteConfirmText}
                onChange={function(e) { self.setState({ deleteConfirmText: e.target.value }); }}
                placeholder="Type DELETE"
                autoFocus
              />
              <div className="tw-flex tw-gap-3">
                <button
                  onClick={this.handleDeleteAccount}
                  disabled={this.state.deleteConfirmText !== 'DELETE' || this.state.deleteLoading}
                  className="tw-px-6 tw-py-3 tw-rounded-lg tw-bg-red-600 tw-text-white tw-font-semibold tw-text-sm tw-border-none tw-cursor-pointer hover:tw-bg-red-700 tw-transition-colors disabled:tw-opacity-40 disabled:tw-cursor-not-allowed"
                >
                  {this.state.deleteLoading ? 'Deleting...' : 'Confirm Delete'}
                </button>
                <button
                  onClick={function() { self.setState({ showDeleteConfirm: false, deleteConfirmText: '', deleteError: '' }); }}
                  className="tw-px-6 tw-py-3 tw-rounded-lg tw-bg-[#e0e0e0] dark:tw-bg-[#333] tw-text-[#111] dark:tw-text-white tw-font-semibold tw-text-sm tw-border-none tw-cursor-pointer hover:tw-bg-[#d0d0d0] dark:hover:tw-bg-[#444] tw-transition-colors"
                >
                  Cancel
                </button>
              </div>
              {this.state.deleteError && (
                <p className="tw-text-sm tw-text-red-600 tw-mt-2">{this.state.deleteError}</p>
              )}
            </div>
          )}
        </div>

        {/* Confirm Modal */}
        {this.state.confirmModal ? (
          <div
            className="tw-fixed tw-inset-0 tw-bg-black/50 tw-flex tw-items-center tw-justify-center tw-z-50"
            onClick={function(e) { if (e.target === e.currentTarget) self.setState({ confirmModal: null }); }}
          >
            <div className="tw-bg-white dark:tw-bg-[#1a1a1a] tw-rounded-xl tw-p-6 tw-w-full tw-max-w-sm tw-mx-4" style={{ border: '1px solid #e0e0e0' }}>
              <h3 className="tw-text-lg tw-font-semibold tw-text-[#111] dark:tw-text-white tw-mb-3">
                {this.state.confirmModal.title}
              </h3>
              <p className="tw-text-sm tw-text-[#555] dark:tw-text-[#aaa] tw-mb-6">
                {this.state.confirmModal.message}
              </p>
              <div className="tw-flex tw-justify-end tw-gap-3">
                <button
                  onClick={function() { self.setState({ confirmModal: null }); }}
                  className="tw-px-5 tw-py-2.5 tw-rounded-lg tw-text-sm tw-font-medium tw-cursor-pointer tw-transition-colors tw-border-none tw-bg-[#f5f5f5] dark:tw-bg-[#333] tw-text-[#555] dark:tw-text-[#aaa]"
                >
                  Cancel
                </button>
                <button
                  onClick={self.state.confirmModal.onConfirm}
                  className="tw-px-5 tw-py-2.5 tw-rounded-lg tw-text-sm tw-font-semibold tw-cursor-pointer tw-transition-colors tw-border-none tw-text-white"
                  style={{ backgroundColor: '#dc2626' }}
                >
                  {self.state.confirmModal.confirmLabel}
                </button>
              </div>
            </div>
          </div>
        ) : null}
      </div>
    );
  }
}

export default AccountSettings;
